import { cn } from '@/lib/utils';

const NATURAL_W = 1528;
const NATURAL_H = 1022;
const ASPECT = NATURAL_W / NATURAL_H;

type Flaming7Props = {
  /** Rendered height in pixels. Width is computed from the natural aspect ratio. */
  size?: number;
  className?: string;
  /** Subtle flame-flicker scale animation. Default true. */
  animated?: boolean;
};

/**
 * Hero "flaming 7" branding asset. Painted artwork lives at
 * /public/brand/flaming-7.png and is bundled with the client build.
 */
export function Flaming7({ size = 120, className, animated = true }: Flaming7Props) {
  const width = Math.round(size * ASPECT);
  return (
    <img
      src="/brand/flaming-7.png"
      alt=""
      aria-hidden="true"
      width={width}
      height={size}
      draggable={false}
      style={{ height: size, width }}
      className={cn(
        'block select-none pointer-events-none',
        animated && 'animate-flame-flicker',
        className,
      )}
    />
  );
}
